module.exports = __webpack_public_path__ + "img/worshipper.afe63416.svg";